var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 18.75v-6a1.5 1.5 0 0 1 1.5-1.5h3.75a.75.75 0 0 1 0 1.5H3v6h18v-6h-3.75a.75.75 0 0 1 0-1.5H21a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-1.5 1.5H3a1.5 1.5 0 0 1-1.5-1.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 12V2.25a.75.75 0 0 1 1.5 0V12a.75.75 0 0 1-1.5 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.97 6.97a.75.75 0 0 1 1.06 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 0 1 1.06-1.06L12 10.94zm1.655 9.905a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"
  })));
};
export default SvgDownload;